import { Facebook, Instagram, Twitter, Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'Gallery', path: '/gallery' },
    { label: 'Areas', path: '/areas' },
    { label: 'Contact', path: '/contact' },
  ];

  const serviceAreas = ['Morris County', 'Sussex County', 'Warren County', 'Hunterdon County', 'Somerset County'];

  return (
    <footer className="bg-navy text-white relative">
      {/* Top flag stripe */}
      <div className="h-1 bg-gradient-to-r from-patriot via-cream to-navy" />

      <div className="container mx-auto px-4 pt-10 pb-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">

          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span
                className="font-display font-bold text-white text-2xl tracking-wide"
                style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.45)' }}
              >
                DeckPros<span className="text-lime">NJ</span>
              </span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-5 font-body">
              Family-owned American deck builders serving New Jersey since 1999. Premium craftsmanship from the ground up.
            </p>
            <div className="flex gap-2">
              {[Facebook, Instagram, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  className="w-9 h-9 border-2 border-white/20 hover:border-patriot hover:bg-patriot flex items-center justify-center text-white/70 hover:text-white transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-patriot mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-patriot" />
              Quick Links
            </h3>
            <ul className="space-y-2">
              {quickLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-white/70 hover:text-patriot transition-colors text-sm font-display uppercase tracking-wide font-medium"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-patriot mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-patriot" />
              Areas We Serve
            </h3>
            <ul className="space-y-2">
              {serviceAreas.map((area) => (
                <li key={area} className="flex items-center gap-2 text-white/70 text-sm">
                  <MapPin className="w-3 h-3 text-patriot flex-shrink-0" />
                  <span className="font-display uppercase tracking-wide font-medium">{area}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-patriot mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-patriot" />
              Contact
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:2016570855" className="flex items-center gap-2 text-white hover:text-patriot transition-colors group">
                  <Phone className="w-4 h-4 text-patriot" />
                  <span className="font-display font-bold text-base">(201) 657-0855</span>
                </a>
              </li>
              <li>
                <a href="mailto:support@allcompleteconstruction.com" className="flex items-center gap-2 text-white/70 hover:text-patriot transition-colors">
                  <Mail className="w-3.5 h-3.5 text-patriot flex-shrink-0" />
                  <span className="text-xs break-all">support@allcompleteconstruction.com</span>
                </a>
              </li>
              <li className="pt-2 border-t border-white/10">
                <div className="text-[10px] text-patriot uppercase tracking-[0.2em] mb-1 font-display font-bold">Business Hours</div>
                <p className="text-white/70 text-xs font-body">Mon–Fri · 7:00 AM – 6:00 PM</p>
                <p className="text-white/70 text-xs font-body">Saturday · 8:00 AM – 4:00 PM</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t-2 border-white/10 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-white/50 font-body">
          <p className="text-center sm:text-left">
            © {currentYear} DeckProsNJ.com · All Rights Reserved · Proudly American
          </p>
          <p>
            Design by{' '}
            <a
              href="https://www.instagram.com/eba_tech?igsh=MWlqb3p4MTNiZ21xbQ=="
              target="_blank"
              rel="noopener noreferrer"
              className="text-patriot hover:text-cream transition-colors font-semibold"
            >
              ebatech
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
